<template>
  <div class="container"> <!-- Contained layout -->
    <div class="row m-3" v-if="applicantData">
      <div class="p-3 col-12 card card-with-shadow border-0">
        <div class="company-header">
          <div v-if="company.logo" class="mb-2">
            <img :src="company.logo" alt="Company Logo" class="img-fluid logo" style="max-height: 60px;" />
          </div>

          <h5 class="fw-bold mb-1" v-if="company.company_name">
            {{ company.company_name }}
          </h5>

          <p class="mb-1 small" v-if="company.premises || company.address_line_1 || company.city || company.country || company.postal_code">
            {{ [company.premises, company.address_line_1, company.city, company.country].filter(Boolean).join(', ') }}
            <span v-if="company.postal_code"> - {{ company.postal_code }}</span>
          </p>

          <p class="mb-2 small">
            <span v-if="company.company_email"><strong>Email:</strong> {{ company.company_email }}</span>
            <span v-if="company.company_phone">
              <span v-if="company.company_email"> | </span>
              <strong>Phone:</strong> {{ company.company_phone }}
            </span>
            <span v-if="company.comapny_number">
              <span v-if="company.company_email || company.company_phone"> | </span>
              <strong>Company No:</strong> {{ company.comapny_number }}
            </span>
          </p>
        </div>
      <div class="row">
        <div class="col-12 col-lg-6">
          <h4>Review & Endorse Your Information</h4>

          <p>
            Hi {{ applicant.full_name }},<br>
            we’ve updated parts of your application. Please review the summary below
            and confirm your endorsement to proceed.
          </p>

          <div class="details">
            <p class="mb-1">
              <strong>Change Summary</strong>
              <small v-if="applicant.log_screening_statuses.length" class="text-muted">
                ({{ applicant.log_screening_statuses.length }})
              </small>
            </p>

            <ul v-if="applicant.log_screening_statuses.length" class="change-list list-unstyled">
              <li v-for="(line, i) in applicant.log_screening_statuses" :key="i" class="change-line">
                <span class="change-dot" aria-hidden="true"></span>
                <!-- keep logic the same: plain text output -->
                <span class="change-text">{{ line.action_comment }}</span>

                <!-- OPTIONAL (purely visual): to highlight the arrow, swap the span above with this one -->
                <!-- <span class="change-text" v-html="line.action_comment.replace('→', '<span class=&quot;arrow&quot;>→</span>')"></span> -->
              </li>
            </ul>

            <p v-else class="text-muted">
              No specific change lines are available. Please review your profile details carefully.
            </p>
          </div>
        </div>

        <div class="col-12 col-lg-6">
            <app-overlay-loader v-if="preloader" />

            <form class="mb-0"
                  :class="{ 'loading-opacity': preloader }"
                  ref="form"
                  :data-url="addurl">

              <div class="row">
                <div class="col-md-6 form-group align-items-center">
                  <label for="inputs_signed_by">{{ $t("signed_by") }}</label>
                  <app-input id="inputs_signed_by" type="text" v-model="inputs.signed_by" placeholder="Enter Name" :required="true" />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 form-group align-items-center">
                  <label for="inputs_endorsed_at">{{ $t("endorsed_at") }}</label>
                  <app-input id="inputs_endorsed_at" type="date" v-model="inputs.endorsed_at" :required="true" />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 form-group align-items-center">
                  <label for="inputs_endorsement_remarks">{{ $t("endorsement_remarks") }}</label>
                  <app-input id="inputs_endorsement_remarks" type="text-editor" placeholder="Enter Remarks" v-model="inputs.endorsement_remarks" />
                </div>
              </div>

              <div class="row" v-if="!inputs.signature">
                <div class="col-md-12 form-group align-items-center">
                  <label>{{ $t("signature") }}</label>
                  <VueSignaturePad id="signature"
                                   width="100%"
                                   height="200px"
                                   ref="signaturePad"
                                   :options="{ onBegin: () => { $refs.signaturePad.resizeCanvas() } }"
                  />
                  <div class="mt-2 d-flex justify-content-end align-items-center">
                    <button @click.prevent="undo" class="btn btn-danger mr-2">Undo</button>
                  </div>
                </div>
                <div class="action-buttons col-md-8 form-group align-items-center">
                  <button type="submit" class="btn btn-primary mr-2" @click.prevent="submitForm">
                    {{ $t("submit") }}
                  </button>
                </div>
              </div>

              <div class="row" v-if="inputs.signature">
                <div class="col-md-12 form-group align-items-center">
                  <label>{{ $t("signature") }}</label>
                  <img :src="inputs.signature" alt="" width="300" />
                </div>
              </div>

            </form>
          </div>
      </div>
      </div>

    </div>
  </div>

</template>

<script>
import {FormMixin} from '../../../../core/mixins/form/FormMixin.js';
import {SCREENING_ENDORSEMENT_UPDATE, SCREENING_ENDORSEMENT_DETAIL} from "../../../Config/ScreeningAppUrl.js";
import { axiosGet } from "@/app/Helpers/AxiosHelper";

  export default {
    name: "ApplicantInformationEndorsement",
    mixins: [FormMixin],
    data() {
      return {
        signaturePath: '',
        inputs: {
          endorsed_at: new Date(),
          endorsement_remarks: '',

        },
        preloader: false,
        companyInfo: {},
        screeningEndorsementId: null,
        addurl: SCREENING_ENDORSEMENT_UPDATE,
        applicantData: {},
        applicant: {},
        company: {},
        endorsement: {},
        isAdmin: false
      };
    },
    created() {
      this.companyInfo = this.$attrs['companyData-prop'];
      this.endorsement = this.$attrs['endorsement-prop'];
      this.screeningEndorsementId = this.$attrs['screeningendorsementid'];
      this.isAdmin = this.$attrs['isadmin'];
      this.getScreeningEndorsementDetail(this.screeningEndorsementId);
      this.setEndorsement();

    },

    methods: {
      submitForm() {
        const {isEmpty, data} = this.$refs.signaturePad.saveSignature();
        if (data != null) {
          this.inputs.signature = data;
          this.inputs.screeningEndorsementId = this.screeningEndorsementId;

          let formData = new FormData();
          Object.keys(this.inputs).forEach((key) => {
            formData.append(key, this.inputs[key]);
          });
          this.save(formData)
        } else {
          this.$toastr.e("Signature is required.");
        }
      },
      beforeSubmit() {
        this.preloader = true;
      },
      afterSuccess(response) {
        this.preloader = false;
        this.$toastr.s(response.data.message);
        this.inputs = {};
        this.undo();
        setTimeout(() => {
          window.close();
        }, 3000);
        this.$toastr.i("Closing window in 3 secs.");

      },
      afterFinalResponse() {
        this.preloader = false;
      },
      afterError(response) {
        console.error("Error caught", response);
        // this.$toastr.e(response.response.data.message);
        this.preloader = false;
      },
      undo() {
        this.$refs.signaturePad.undoSignature();
      },
      getScreeningEndorsementDetail(screeningEndorsementId) {
        axiosGet(SCREENING_ENDORSEMENT_DETAIL + screeningEndorsementId+"/applicantEndorsement")
            .then((res) => {
              this.applicantData = res.data;
              this.applicant = res.data.endorseable.applicant;
              this.company = res.data.endorseable.company;
            })
            .catch((error) => {

            });
      },
      setEndorsement() {

        if (this.isAdmin) {

          this.inputs = this.endorsement


        }
      },
    },




  };
</script>
<style scoped>
.company-header {
  border-bottom: 1px solid #dee2e6;
  padding: 1rem;
  margin-bottom: 1.5rem;
  background-color: #f8f9fa;
  border-radius: 0.25rem;
}
 .change-list { margin: 0; padding: 0; }
.change-line {
  display: flex; gap: 10px; align-items: flex-start;
  padding: 10px 12px; margin-bottom: 8px;
  background: #fafafa; border: 1px solid #eee; border-radius: 10px;
}
.change-dot {
  width: 8px; height: 8px; border-radius: 50%; background: #0d6efd; margin-top: 8px; flex: 0 0 8px;
}
.change-text {
  white-space: pre-wrap;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace;
  line-height: 1.45;
}
.change-text .arrow { font-weight: 700; }
</style>

</style>